import checkbox from '../../../../checkbox';

const dark = (params) => checkbox.switchedOn.background.default.dark(params);

export default dark;
